import { useState } from 'react';
import BarcodeDesignController from './BarcodeDesignController';
import Loader from 'components/Loader';
import { Paper, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

function BarcodeDesign() {
  const {
    barcodeData,
    handleClearButtonClick,
    handleRemoveBarcode,
    handleProceed,
    addMoreBarcode,
    isDataLoading,
    setIsDataLoading
  } = BarcodeDesignController();

  const shouldRenderTable = barcodeData && barcodeData.length > 0;

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [designNumber, setDesignNumber] = useState('');
  const [designError, setDesignError] = useState('');
  

  // ✅ Open Dialog when Add More button clicked
  const handleAddMoreClick = () => {
    setIsDialogOpen(true);
  };

  // ✅ Close Dialog
  const handleCloseDialog = () => {
    if (!isDataLoading) {
      setIsDialogOpen(false);
      setDesignNumber('');
      setDesignError('');
    }
  };

  const handleDialogOk = async () => {
    if (!designNumber.trim()) {
      setDesignError('Design Number is required');
      return;
    }

    setIsDataLoading(true);
    console.log('✅ Design Number entered--->>>', designNumber);

    // ✅ Fetch new data and append to table
    await addMoreBarcode(designNumber);

    setIsDataLoading(false);
    setIsDialogOpen(false);
    setDesignNumber('');
    setDesignError('');
  };

  const handleProceedClick = async () => {
    setIsDataLoading(true);
    try {
      await handleProceed();
    } finally {
      setIsDataLoading(false);
    }
  };

  return (
    <div className="bg" style={{ display: 'block' }}>
      {isDataLoading ? (
        <div className="overlay">
          <Loader />
          <span style={{ marginLeft: '10px' }}>Data Loading...</span>
        </div>
      ) : null}
      <div className="cutrange">
        <span className="font20">SAMPLE DESIGN</span>
      </div>
      {/* <div className="cutrange" style={{ justifyContent: 'end' }}>
        <span style={{ marginRight: '20px' }}>Total :</span>
        <input
          value={barcodeData.length}
          readOnly
          type="text"
          name="cfrom"
          style={{ width: '80px', marginRight: '20px', textAlign: 'center' }}
          className={`inp_text`}
          id="cfrom"
        />
      </div> */}
      <div className="vertical-center">
        {shouldRenderTable ? (
          <div className="barcode-so">
            <Paper
              elevation={3}
              sx={{
                // width: { xs: '95%', sm: '85%', md: '70%' },
                margin: 'auto',
                borderRadius: '8px',
                overflow: 'hidden'
              }}
            >
              {/* <Box sx={{ px: 2, py: 1.5, borderBottom: '1px solid #e5e5e5' }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                  Design List ({barcodeData.length})
                </Typography>
              </Box> */}
              <Box
                sx={{
                  p: 2,
                  overflowY: 'auto',
                  display: 'grid',
                  gridTemplateColumns: {
                    xs: '1fr',
                    sm: 'repeat(2, minmax(0, 1fr))',
                    md: 'repeat(3, minmax(0, 1fr))'
                  },
                  gap: 1.5
                }}
              >
                {barcodeData.map((Item, Index) => (
                  <Box
                    key={Index}
                    sx={{
                      border: '1px solid #d9d9d9',
                      borderRadius: '6px',
                      p: 1.5,
                      backgroundColor: '#fafafa'
                    }}
                  >
                    <Typography variant="caption" sx={{ color: '#666' }}>
                      Barcode
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
                      {Item.barcode}
                    </Typography>

                    <Typography variant="caption" sx={{ color: '#666' }}>
                      Material
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 1.5 }}>
                      {Item.materialDesc}
                    </Typography>

                    <button
                      style={{
                        fontSize: '12px',
                        padding: '6px 8px',
                        borderRadius: '3px',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer'
                      }}
                      onClick={() => handleRemoveBarcode(Item.barcode)}
                    >
                      Remove
                    </button>
                  </Box>
                ))}
              </Box>
            </Paper>
          </div>
        ) : null}
        {!isDataLoading && !shouldRenderTable ? (
          <Typography variant="h6" sx={{ color: '#fff', mt: 2 }}>
            No Data Found
          </Typography>
        ) : null}
      </div>

      <div className="footer-button">
        <button onClick={handleClearButtonClick} style={{ marginRight: '15px' }}>
          {'Clear'}
        </button>
        <button style={{ marginRight: '15px' }} onClick={handleAddMoreClick}>
          {'Add More Design'}
        </button>
        <button style={{ marginRight: '15px' }} onClick={handleProceedClick} disabled={isDataLoading}>
          {'Proceed'}
        </button>
      </div>

      <Dialog open={isDialogOpen} onClose={handleCloseDialog} maxWidth="xs" fullWidth>
        <DialogTitle>Enter Design Number</DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 1 }}>
            <TextField
              autoFocus
              fullWidth
              label="Design Number"
              variant="outlined"
              value={designNumber}
              onChange={(e) => {
                setDesignNumber(e.target.value);
                if (designError) setDesignError('');
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') handleDialogOk();
              }}
              helperText={designError}
              error={!!designError}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} disabled={isDataLoading}>
            Cancel
          </Button>
          <Button variant="contained" onClick={handleDialogOk} disabled={isDataLoading}>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default BarcodeDesign;
